import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { ActivityReply } from "../../../../@types/activities.ts";
import { MouseEvent } from "react";
import classNames from "classnames";
import TranslationIndicator from "../../../shared/TranslationIndicator.tsx";

export default function ReplyQuote({
  author,
  content,
  handleCancelQuote,
  className,
  translated,
}: ActivityReply["quote_data"] & {
  handleCancelQuote?: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  translated?: boolean;
}) {
  return (
    <div
      className={classNames(
        "quote_block pl-2 border-l-4 border-primary bg-gray-50 py-1 rounded-md mb-4 relative",
        className,
      )}
    >
      <div className="flex justify-between items-start">
        <a
          href={author.url}
          className="font-semibold member-link member-name mb-1"
        >
          {`${author.displayName}${
            author.is_external ? ` (${I18n.t("js.external_member.badge")})` : ""
          }`}
        </a>
        {handleCancelQuote && (
          <div className="cancel-quote btn btn-sm text-muted absolute top-2 right-2">
            <button
              className="btn btn-sm p-0"
              onClick={handleCancelQuote}
              title={I18n.t("js.cancel")}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        )}
      </div>
      <div
        className="text-gray-600 mt-1"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      {translated && <TranslationIndicator />}
    </div>
  );
}
